import { Component, Input, OnInit, inject } from '@angular/core';
import {ButtonModule} from "primeng/button";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {DataViewModule} from "primeng/dataview";
import {MenuModule} from "primeng/menu";
import {OrderListModule} from "primeng/orderlist";
import {SharedModule} from "primeng/api";
import {SkeletonModule} from "primeng/skeleton";
import {SplitButtonModule} from "primeng/splitbutton";
import {TooltipModule} from "primeng/tooltip";
import {
    DataService
} from "../../../service/data.service";
import {ProjectDescriptorUse} from 'src/app/api/enums';
import {DividerModule} from "primeng/divider";
import {InputTextModule} from "primeng/inputtext";
import {TextareaModule} from "primeng/textarea";
import {FormsModule} from "@angular/forms";
import {ProjectDescriptorPanelComponent} from "../../project-descriptor/project-descriptor-panel.component";
import {ToggleSwitchModule} from "primeng/toggleswitch";
import {Project} from "../../../api/db/entities/Project";
import {Router} from "@angular/router";
import {ProjectSchemas} from "../../../api/project_schemas";
import {ProjectProfileGroup} from "../../../api/db/entities/ProjectProfileGroup";

import { WriterTemplatesComponent, templateInterface } from '../../utilities/templates/writer-templates.component';
import {EditorModule} from 'primeng/editor';
import {SelectModule} from "primeng/select";
import {FloatLabel} from "primeng/floatlabel";

@Component({
    selector: 'project-profile',
    imports: [
        ButtonModule,
        ConfirmDialogModule,
        DataViewModule,
        MenuModule,
        OrderListModule,
        SharedModule,
        SkeletonModule,
        SplitButtonModule,
        TooltipModule,
        DividerModule,
        InputTextModule,
        TextareaModule,
        FormsModule,
        ProjectDescriptorPanelComponent,
        ToggleSwitchModule,
        SelectModule,
        WriterTemplatesComponent,
        EditorModule,
        FloatLabel
    ],
    templateUrl: './project-profile.component.html'
})

export class ProjectProfileComponent {
    private dataService = inject(DataService);
    private router = inject(Router);

    protected title: string | null;
    protected summary: string | null;
    protected lastInfo: string | null;
    private lastInfoTextElement: HTMLInputElement;




    _project: Project;
    get project(): Project {
        return this._project;
    }
    // TODO: Skipped for migration because:
    //  Accessor inputs cannot be migrated as they are too complex.
    @Input() set project(value: Project) {
        this._project = value;
        console.log("Project Profile setting: ", value);
        console.log("Project Profile Group: ", value.profileGroup);
        if (!this.project.profileGroup) {
            this.project.profileGroup = new ProjectProfileGroup();
            this.project.profileGroup.profileSelections = [];
            this.project.profileGroup.projectSchemaCode = this.project.schemaCode;
        }
        console.log("Project Profile setting after: ", value);
        console.log("Project Profile Group after: ", value.profileGroup);
    }

    save() {
        console.log(this.project.profileGroup);
        //console.log(this.values);
        this.dataService.saveProjectTempToProfile(this.project, this.project.profileGroup);
        this.router.navigate(['/', 'writer', this.project.uuid]);
        //this.dataService.setSelectedProject(this.project);
    }

    protected readonly ProjectDescriptorUse = ProjectDescriptorUse;
    protected readonly ProjectSchemas = ProjectSchemas;
}

